<template>
  <div class="modal-share"  @click="close(false)">
    <div class="modal-body">
      <img src="~assets/imgs/share-tip.png" />
    </div>
  </div>
</template>
<script>
  export default {
    methods: {
      close(status){
        this.$emit('showModalShare', status );
        // this.show = status || !this.show;
      },
    }
  }
</script>
<style lang="scss">
  .modal-share{
    position: fixed;
    left:0;top:0;
    width: 100vw;
    height: 100vh;
    z-index: 110;
    font-size: inherit;
    background-color: rgba(0, 0, 0, 0.6);
    .modal-body{
      position: absolute;
      top:0;right: 0;
    }
    img{
      width: 40vw;
      margin: 0 4vw 0 0 ;
    }
  }
</style>